// extracted by mini-css-extract-plugin
module.exports = {"Table":"Table_Table__6Irq-","line":"Table_line__37h-5"};